import { IGetCategoriesResponse, IPostCategoriesRequest, IPostCategoriesResponse } from 'types';
import { IKeywordCategoriesExcelData } from 'pages/Keywords/types';
import { cdmApi } from '.';

const PREFIX = '/keyword-categories';

const productKeywordsApi = cdmApi.injectEndpoints({
    endpoints: (builder) => ({
        getKeywordCategories: builder.query<IGetCategoriesResponse, void>({
            query: (params) => ({ url: `${PREFIX}/`, method: 'get', params }),
            providesTags: () => [{ type: 'KeywordCategories', id: 'LIST' }],
        }),

        updateKeywordCategories: builder.mutation<IPostCategoriesResponse, IPostCategoriesRequest[]>({
            query: (data) => ({ url: `${PREFIX}/`, method: 'post', data }),
            invalidatesTags: [{ type: 'KeywordCategories', id: 'LIST' }],
        }),

        exportKeywordCategories: builder.query<ArrayBuffer, { isTemplate?: boolean }>({
            query: (params) => ({
                url: `${PREFIX}/excel/export`,
                method: 'get',
                params,
                responseType: 'arraybuffer',
            }),
        }),

        uploadKeywordCategories: builder.mutation<any, FormData>({
            query: (data) => ({ url: `${PREFIX}/excel/upload`, method: 'POST', data }),
            invalidatesTags: [{ type: 'KeywordCategories', id: 'LIST' }],
        }),

        exportKeywordCategoriesErrors: builder.mutation<ArrayBuffer, IKeywordCategoriesExcelData[]>({
            query: (data) => ({
                url: `${PREFIX}/excel/error`,
                method: 'post',
                data,
                responseType: 'arraybuffer',
            }),
        }),
    }),

    overrideExisting: false,
});

export const {
    useGetKeywordCategoriesQuery,
    useUpdateKeywordCategoriesMutation,
    useLazyExportKeywordCategoriesQuery,
    useUploadKeywordCategoriesMutation,
    useExportKeywordCategoriesErrorsMutation,
} = productKeywordsApi;
